module.exports = __webpack_public_path__ + "img/logo-cnastore.d0d15d5c.svg";